import React from 'react';
import { useToast } from '../../contexts/ToastContext';

/* Tone-aware palette. Falls back to v1 `type` styling when toast has
 * no `tone` (legacy callers). For v2 callers we render title +
 * description in a richer card; v1 callers still get the simple
 * single-line look they always had. */
const TONE_PALETTE = {
  success: { bg: '#0d9488', text: '#ffffff', accent: '#14b8a6' },
  warn:    { bg: '#d97706', text: '#ffffff', accent: '#f59e0b' },
  error:   { bg: '#dc2626', text: '#ffffff', accent: '#ef4444' },
  info:    { bg: '#0e1f3a', text: '#ffffff', accent: '#2cd9c5' },
};

export function Toast() {
  const { toasts, removeToast } = useToast();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 50,
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        maxWidth: 380,
      }}
    >
      {toasts.map((toast) => {
        const palette = TONE_PALETTE[toast.type] || TONE_PALETTE.info;
        const hasRich = toast.title && toast.description;
        return (
          <div
            key={toast.id}
            role="status"
            style={{
              padding: hasRich ? '12px 14px' : '12px 16px',
              borderRadius: 10,
              background: palette.bg,
              color: palette.text,
              fontSize: 13,
              fontFamily: "'Inter', 'DM Sans', system-ui, sans-serif",
              boxShadow: '0 8px 24px rgba(15, 23, 42, .18)',
              borderLeft: `3px solid ${palette.accent}`,
              animation: 'slideUp 0.2s ease-out',
              pointerEvents: 'auto',
              cursor: 'pointer',
              wordWrap: 'break-word',
            }}
            onClick={() => removeToast(toast.id)}
          >
            {hasRich ? (
              <>
                <div style={{ fontWeight: 700, fontSize: 13.5, marginBottom: 3, letterSpacing: '0.005em' }}>{toast.title}</div>
                <div style={{ fontSize: 12.5, opacity: 0.9, lineHeight: 1.45 }}>{toast.description}</div>
              </>
            ) : (
              /* Defensive: only render strings/elements. If someone
               * still managed to pass an object as the message, render
               * a JSON snippet rather than crashing. */
              typeof toast.message === 'string' || React.isValidElement(toast.message)
                ? toast.message
                : (toast.title || toast.description || JSON.stringify(toast.message))
            )}
          </div>
        );
      })}
    </div>
  );
}
